<template>
  <div class="yh-page">
    <el-card>
      <el-row slot="header" type="flex" justify="space-around" align="middle" class="p-3">
        <el-radio-group v-model="creator" @change="handleCreatorChange" size="small">
          <el-radio-button label="all">全部</el-radio-button>
          <el-radio-button label="my">我的</el-radio-button>
        </el-radio-group>
        <el-select v-model="query.insurance_company" size="small" clearable placeholder="请选择保险公司" class="w-25"
          @change="handleCompanyChange">
          <el-option v-for="company in company_list" :key="company.id" :label="company.name" :value="company.id">
          </el-option>
        </el-select>
        <el-select placeholder="请选择业务部门" v-model="query.department" filterable clearable @change="handleSearch">
            <el-option v-for="g in groupList" :key="g.id" :value="g.name"></el-option>
          </el-select>
        <el-input placeholder="输入船舶信息进行搜索..." v-model.trim="query.search" @keyup.enter.native="handleSearch"
          class="w-50" size="small">
          <el-button slot="append" icon="el-icon-search" v-loading="searching" @click="handleSearch">搜索</el-button>
        </el-input>

        <el-button type="primary" size="small" icon="el-icon-plus" v-if="$perm(['form.add_app_form'])"
          @click="$router.push({ name: 'createInsuranceWithForm' })">新增
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-s-claim"
          @click="showBatchSendDialog">批量签署
        </el-button>
      </el-row>
      <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" fit
        highlight-current-row class="w-100" :show-header="false" @selection-change="handleSelect">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-row>
              <el-col>
                <span class="yh-section-title text-link" @click="handleView(scope.row)">{{`[${scope.row.id}_ins${scope.row.insurance}] ` + scope.row.name}}</span>
                &nbsp;
                <el-tag type="info" size="mini" v-if="scope.row.create_type === 0">自制</el-tag>
                <el-tag type="danger" size="mini" v-else-if="[1, 2].indexOf(scope.row.create_type) !== -1">他制</el-tag>
              </el-col>
            </el-row>
            <el-row type="flex" align="middle" class="py-2">
              <el-col :span="7">
                <div>
                  <!-- <span class="yh-section-title text-link" @click="handleView(scope.row)">{{`[${scope.row.id}_ins${scope.row.insurance}] ` + scope.row.name}}</span> -->
                  <div style="font-size: 1.2em">
                    <i class="el-icon-time"></i>
                    创建时间 : {{ scope.row.create_time | parseTime }}
                  </div>
                  <div style="font-size: 1.2em">
                    <i class="el-icon-time"></i>
                    更新时间 : {{ scope.row.update_time | parseTime }}
                  </div>
                </div>
              </el-col>
              <el-col :span="2">
                <span v-if="scope.row.status === '1'" class="badge badge-success mr-2">完成</span>
                <span v-else-if="scope.row.status === '0'" class="badge badge-warning mr-2">未完成</span>
              </el-col>
              <el-col :span="2">
                <el-tooltip class="item" effect="dark" :content=getSignTooltip(scope.row.file)  placement="top">
                  <span v-if="scope.row.file && scope.row.file.status === 0" class="badge badge-primary mr-2">未签署</span>
                  <span v-else-if="scope.row.file && scope.row.file.status === 1" class="badge badge-warning mr-2">签署中</span>
                  <span v-else-if="scope.row.file && scope.row.file.status === 2" class="badge badge-success mr-2">已签署</span>
                  <span v-else class="badge badge-default mr-2">未发起签署</span>
                </el-tooltip>
              </el-col>
              <el-col :span="2">
                <span class="badge badge-info">{{ scope.row.creator_name }}</span>
              </el-col>
              <el-col :span="7">
                <div>
                  <span class="font-weight-bold text-link" @click="handleViewInsurance(scope.row.insurance)">{{
                      scope.row.insurance_name
                  }}</span>
                </div>
                <div>
                  <span>{{ scope.row.company_name }}</span>
                </div>
              </el-col>
              <el-col :span="3">
                <div>
                  <span class="font-weight-bold">{{ scope.row.type_name }}</span>
                </div>
                <div>
                  <span>{{ scope.row.scheme_name }}</span>
                </div>
              </el-col>
              <el-col :span="3">
                <el-tooltip effect="light" content="编辑" placement="top-start" v-if="true || (!scope.row.issued & scope.row.is_lock==null) || (scope.row.is_lock===false)">
                  <el-button type="text" class="pr-1" @click="handleView(scope.row)">
                    <svg-icon icon-class="edit"></svg-icon>
                  </el-button>
                </el-tooltip>

                <el-tooltip effect="light" content="申请修改" placement="top-start" v-if="false">
                  <el-button type="text" class="pr-1" @click="handleModifyApplication(scope.row)">
                    <i class="el-icon-document"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip effect="light" placement="top-start" content="复制" v-if="scope.row.status === '1'">
                  <el-button type="text" class="pr-1" @click="handleCopy(scope.row.id)">
                    <i class="el-icon-document-copy"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip effect="light" placement="top-start" content="查看出单数据">
                    <el-button type="text" @click="ShowDialog(scope.row.id)" ><i class="el-icon-view"></i></el-button>
                </el-tooltip>

                <!-- 在线签署相关功能键 -->
                <span v-if="(scope.row.file !== null) && (scope.row.file.id)">
                  &nbsp;
                  <el-tooltip effect="light" content="发送签署" placement="top-start">
                    <el-button type="text" @click="showSendDialog(scope.row)">
                      <i class="el-icon-s-claim"></i>
                    </el-button>
                  </el-tooltip>
                  <el-tooltip effect="light" content="签署链接" placement="top-start">
                    <el-button type="text" v-show="(scope.row.file.file_sign.length != 0) && (scope.row.file.file_sign[0].receiver)"
                              @click="signUrl(scope.row.file.file_sign[0].id)"><i class="el-icon-link"></i></el-button>
                  </el-tooltip>
                  <el-tooltip effect="light" content="催签" placement="top-start">
                    <el-button type="text" v-show="(scope.row.file.file_sign.length != 0) && (scope.row.file.file_sign[0].receiver)"
                              @click="handleUrgeSign(scope.row.file.file_sign[0].id)"><i class="el-icon-alarm-clock"></i></el-button>
                  </el-tooltip>
                  <el-tooltip effect="light" content="撤销" placement="top-start">
                    <el-button type="text" v-show="(scope.row.file.file_sign.length != 0) && [0, 1].indexOf(scope.row.file.file_sign[0].sign_flow_status) !== -1"
                              @click="handleRevokeSign(scope.row.file.file_sign[0].id)"><i class="el-icon-s-release"></i></el-button>
                  </el-tooltip>
                </span>

                <!--el-tooltip v-if="scope.row.status === '1'" class="item" effect="light" content="导出" placement="top-start">
                  <el-button type="text"><i class="el-icon-download" @click="handleExport(scope.row)"></i></el-button>
                </el-tooltip-->
                <el-dropdown v-if="scope.row.status === '1'" class="ml-2" @command="handleCommand($event, scope.row)">
                  <el-button type="text"><i class="el-icon-download"></i></el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="exp_pdf" v-show="scope.row.create_type === 0">导出PDF</el-dropdown-item>
                    <el-dropdown-item command="exp_electron" v-show="[1,2].indexOf(scope.row.create_type) !== -1">导出原投保单</el-dropdown-item>
                    <el-dropdown-item command="exp_signed" v-show="scope.row.file && scope.row.file.status === 2">
                      导出已签署文件</el-dropdown-item>
                    <!-- 关闭导出非PDF投保单功能
                    <el-dropdown-item command="exp_excel" :disabled="[4].indexOf(scope.row.insurance_company) === -1">
                      导出EXCEL</el-dropdown-item>
                    <el-dropdown-item command="exp_pdf_excel"
                      :disabled="[4].indexOf(scope.row.insurance_company) === -1">导出PDF 和 EXCEL</el-dropdown-item>
                    -->
                  </el-dropdown-menu>
                </el-dropdown>

                <el-tooltip v-if="scope.row.status === '0'" effect="light" content="删除" placement="top-start">
                  <el-button type="text" @click="handleDelete(scope.row)">
                    <i class="el-icon-delete"></i>
                  </el-button>
                </el-tooltip>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <pagination ref="pagination" :size.sync="query.limit" :offset.sync="query.offset" :total="total"
        @updateList="getList"></pagination>
    </el-card>

    <el-dialog :visible.sync="InfoVisible" width="100%">
      <el-form label-width="120px">
        <el-form-item label="出单内容" width="100%">
          <el-input type="textarea" disabled :rows="10" v-model="content"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="InfoVisible=false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="填写签署日期" :visible.sync="dialogVisible">
      <el-form label-position="right" label-width="150px" v-loading="downloading" :element-loading-text="downloadingText">
        <el-row>
          <el-col>
            <el-form-item label="签署日期">
              <el-date-picker
                v-model="write_date"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="border-top mt-2 pt-3">
            <el-form-item>
              <el-button size="small" type="primary" style="float: right" @click="handlePrint">导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog title="签署人选择" :visible.sync="dialogSendVisible" :show-close="false">
      <el-form label-position="left" label-width="150px">
        <el-form-item label="签署方类型">
          <el-radio-group v-model="signer_type">
            <el-radio :label="0">个人</el-radio>
            <el-radio :label="1">公司</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="签署人">
          <el-select v-model="signer_mobile" filterable placeholder="请选择签署人">
            <el-option v-for="contact in contacts" :key="contact.id"
            :label="contact.name + '(' + restricted_mobile(contact.mobile) + ')'"
            :value="contact.mobile"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="signer_type === 1" label="签署方公司名称">
          <el-select v-model="signer_org_name" filterable placeholder="请选择签署方公司名称">
            <el-option v-for="org in org_list" :key="org.id"
                :label="org.name" :value="org.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelSend">取 消</el-button>
        <el-button :disabled="signer_mobile === ''" type="primary" @click="sendSign">确 定</el-button>
      </div>
    </el-dialog>

    <form-modify-application-dialog ref="modify_application" @updateList="getList"></form-modify-application-dialog>
    <electronic-forms-dialog ref="ele_forms" @updateList="getList"></electronic-forms-dialog>
  </div>
</template>

<script>
import loading from '@/mixins/loading'
import { fetchList as fetchAppformList, exportAppForm, deleteAppForm, copyAppForm,getExceptContent, getRelateContact} from '@/api/form'
import { fetchList as fetchCompanyList } from "@/api/insurance_company"
import {signFile, urgeSign, revokeSign, getSignUrl} from '@/api/sign'
import Pagination from '@/components/Pagination'
import FormModifyApplicationDialog from './form-modify-application-dialog'
import ElectronicFormsDialog from './electronic-forms-dialog'
import {download, getSignTooltip} from '@/utils'
import { fetchList as fetchGroupList } from "@/api/group";

export default {
  name: "appform-list",
  mixins: [loading],
  components: {
    Pagination,
    FormModifyApplicationDialog,
    ElectronicFormsDialog
},
  computed: {
    is_not_pingan() {
      return ([4].indexOf(this.insurance_company) === -1)
    }
  },
  data() {
    return {
      dialogVisible:false,
      creator: 'all',
      InfoVisible: false,
      content:"",
      from_id:"",
      write_date:"",
      query: {
        search: '',
        creator: undefined,
        insurance_company: null,
        offset: 0,
        limit: 20
      },
      total: 0,
      list: [],
      company_list: [],
      dialogSendVisible: false,
      contacts: [],
      org_list: [],
      signer_mobile: '',
      signer_type: 0,
      signer_org_name: '',
      groupList:[],
      begin_time: '',
      file: {},
      multipleSelection: [],
      sendType: ""
    }
  },
  methods: {
    getSignTooltip,
    restricted_mobile(mobile) {
      if (mobile && !this.$perm(['contact.list_contact']) && !this.$perm(['contact.all_contact']) && this.$perm(['contact.restricted_list_contact'])) {
        let value = mobile.slice(0, 3)
        var l = mobile.slice(3, 7).length
        for (var i=0; i<l; i++) {
          value += '*'
        }
        value += mobile.slice(7)
        return value
      }
      return mobile
    },
    handlePrint(){
      this.handleExport(this.from_id, 'pdf',this.write_date)
    },
    ShowDialog(id) {
      this.InfoVisible = true
      getExceptContent(id).then(res => {
        // console.log(res)
        this.content = res.result

      })
    },

    handleCreatorChange(value) {
      let query = Object.assign({}, this.$route.query)
      if (value) {
        this.$set(query, 'scope', value)
      } else {
        delete query.scope
      }
      this.$router.replace({ name: 'appFormList', query: query })
      if (value === 'my') {
        let user = this.$store.getters['user']
        this.$set(this.query, 'creator', user)
      } else {
        this.$set(this.query, 'creator', undefined)
      }
      this.getList()
    },
    handleCompanyChange(value) {
      let query = Object.assign({}, this.$route.query)
      if (value) {
        this.$set(query, 'insurance_company', value)
      } else {
        delete query.insurance_company
      }
      this.$router.replace({ name: 'appFormList', query: query })
      this.getList()
    },
    handleSearch() {
      // this.getList()
      this.$refs.pagination.backNumOne()
    },
    getList() {
      // 从数据库中加载用户数据
      this.loading = true
      fetchAppformList(this.query)
        .then(res => {
          this.list = res.results
          this.total = res.count
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$error_message(error)
        })
    },
    loadData() {
      fetchCompanyList()
        .then(res => {
          this.company_list = res
        })
        .catch(error => {
          this.$error_message(error)
        })
        this.loading = true
          let p = []
          p.push(fetchGroupList())

          Promise.all(p)
          .then(res => {
            this.groupList = res[0]
          })
          .catch(err => {
            this.loading = false
            this.$error_message(err)
          })
    },
    handleView(row) {
      if (row.create_type === 0) {
        let route
        route = this.$router.resolve({
          name: 'viewAppForm',
          query: {
            insurance_id: row.insurance, insurance_company: row.insurance_company, scheme_id: row.scheme,
            scheme_id2: row.scheme,
          }
        })
        // console.log(route)
        open(route.href, "_blank")
      }
      else if ([1, 2].indexOf(row.create_type) !== -1) {
        console.log('弹出切换投保单框')
        this.$refs.ele_forms.handleOpen(row)
      }
    },
    handleCommand(command, form) {
      switch (command) {
        case 'exp_pdf':
          this.dialogVisible = true
          this.from_id = form
          break

        case 'exp_excel':
          this.handleExport(form, 'excel')
          break

        case 'exp_pdf_excel':
          this.handleExport(form, 'pdf')
          this.handleExport(form, 'excel')
          break

        case 'exp_signed':
          download(form.file.child_obj)
          break

        case 'exp_electron':
          if (form.file) {
            download(form.file)
          }
          else {
            this.$error_message("找不到原投保单")
          }
          break
      }
    },
    handleExport(form, file_type,write_date) {
      if (form.status !== '1') {
        this.$message.error("投保单尚未填写完成，请填写完成后再导出")
        return
      }

      this.downloading = true
      this.downloadingText = '正在导出投保单，请稍等...'
      exportAppForm(form.id, file_type,write_date)
        .then(res => {
          let link = document.createElement('a')
          link.style.display = 'none'

          let blob = new Blob([res])
          link.href = URL.createObjectURL(blob)

          let ext_name = '.pdf'
          switch (file_type.toLowerCase()) {
            case 'pdf':
              ext_name = '.pdf'
              break
            case 'excel':
              ext_name = '.xlsx'
              break
            default:
              ext_name = '.pdf'
              break
          }
          link.download = form.name + ext_name
          document.body.appendChild(link)

          link.click()
          URL.revokeObjectURL(blob)
          document.body.removeChild(link)
          this.downloading = false
        })
        .catch(error => {
          this.downloading = false
          let reader = new FileReader()
          reader.onload = e => {
            if (e.target.readyState === 2) {
              let res = {}
              res = JSON.parse(e.target.result)
              this.$error_message(res)
            }
          }
          reader.readAsText(error)
        })
    },
    handleDelete(form) {
      if (form.status !== '0') {
        this.$message.error("投保单当前状态不可删除")
        return
      }

      var msg = '是否删除投保单 ' + form.name + ' ？'
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        deleteAppForm(form.id)
          .then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getList()
          })
          .catch(error => {
            this.$error_message(error)
          })
      })
    },
    handleViewInsurance(insurance_id) {
      const route = this.$router.resolve({ name: 'viewInsurance', query: { id: insurance_id } })
      open(route.href, '_blank')
    },
    handleCopy(id) {
      this.$confirm('复制该投保单信息, 是否继续?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        copyAppForm(id)
          .then(() => {
            this.$nextTick(() => {
              this.$message({
                type: 'success',
                message: '复制投保单信息成功!'
              });
              setTimeout(() => {
                this.getList()
              }, 1000)
            })
          })
          .catch(error => {
            this.$message.error(error)
          })
      }).catch((e) => {
        console.log(e)
        this.$message({
          type: 'info',
          message: '操作取消'
        });
      });
    },
    handleSelect(val) {
      this.multipleSelection = val;
    },
    showBatchSendDialog() {
      const insurance_names = new Set();
      const files = new Array()
      var _index = 0

      this.multipleSelection.forEach(item => {
        insurance_names.add(item.insurance_name)
        if ((item.file !== null) && (item.file.id)) {
          files.push(item.file)
        }
        else {
          this.$error_message(item.insurance_name + "投保单已签署或未生成，请检查")
          _index += 1
        }
      });

      if (_index > 0) {
        return
      }

      if (insurance_names.size !== 1) {
        this.$error_message("所选投保对象不一致，请检查")
        return
      }

      getRelateContact({'id': this.multipleSelection[0].id})
      .then(res => {
        this.contacts = res.contact_list
        this.org_list = res.org_list
        this.dialogSendVisible = true
        this.begin_time = this.multipleSelection[0].begin_time
        this.sendType = "multiple"
        this.$set(this.file, 'file_list', files)
      })
      .catch(err => {
        this.$error_message(err)
      })
    },
    handleModifyApplication(appform) {
      this.$refs.modify_application.handleOpen(appform)
    },
    showSendDialog(row) {
      getRelateContact({'id': row.id})
      .then(res => {
        // console.log(res)
        this.contacts = res.contact_list
        this.org_list = res.org_list
        this.dialogSendVisible = true
        this.file = row.file
        this.begin_time = row.begin_time
        this.sendType = "single"
      })
      .catch(err => {
        this.$error_message(err)
      })
    },
    handleCancelSend() {
      this.dialogSendVisible = false
      this.signer_mobile = ''
      this.file = {}
    },
    sendSign() {
      var text = ''
      if (this.sendType === 'single') {
        console.log("单一签署")
        text = '是否发送文书' + '《' + this.file.name + '》至' + this.restricted_mobile(this.signer_mobile) + '进行签署？'
      }
      else if (this.sendType === 'multiple') {
        console.log("批量签署")
        text = '是否批量发送文书至' + this.restricted_mobile(this.signer_mobile) + '进行签署？'
      }
      
      console.log(this.file)
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogSendVisible = false
        this.loading = true
        this.$set(this.file, 'signer_mobile', this.signer_mobile)
        this.$set(this.file, 'file_type', 'app_form')
        this.$set(this.file, 'begin_time', this.begin_time)
        this.$set(this.file, 'send_type', this.sendType)
        this.$set(this.file, 'signer_type', this.signer_type)
        this.$set(this.file, 'signer_org_name', this.signer_type === 1 ? this.signer_org_name : '')

        signFile(this.file)
        .then(res => {
          this.$message({
            type: 'success',
            message: '已通知手机号为: ' + this.restricted_mobile(this.signer_mobile) + ' 的客户进行签署'
          });
        })
        .catch((err) => {
          this.$message.error({
            message: err
          });
        })
        .finally(() => {
          this.loading = false
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消发送签署'
        });       
      });
    },
    handleUrgeSign(sign_id) {
      urgeSign(sign_id)
      .then(res => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '已发送催签短信'
          })
        }
        else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    signUrl(sign_id) {
      getSignUrl(sign_id)
      .then(res => {
        if (res.code === 0) {
          this.$alert('签署链接为：' + res.data.shortUrl)
        }
        else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    handleRevokeSign(sign_id) {
      this.$confirm('是否撤销签署', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        revokeSign({'sign_id': sign_id}).then(res => {
          this.loading = false
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '已撤销签署'
            })
            this.getList()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
      })
    }
  },
  mounted() {
    var scope = this.$route.query.scope
    var insurance_company = parseInt(this.$route.query.insurance_company)
    insurance_company = isNaN(insurance_company) ? 0 : insurance_company

    if (scope === 'my') {
      this.creator = 'my'
      let user = this.$store.getters['user']
      this.$set(this.query, 'creator', user)
    }
    if (insurance_company > 0) {
      this.$set(this.query, 'insurance_company', insurance_company)
    }
    this.loadData()
    this.getList()
  }
}
</script>
